import styled, { css } from "styled-components";

export const PromotionSelectStyles = styled.div`
  width: 100%;
  border: 1px solid #e4e4e4;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-bottom: 2rem;
  transition: all ease-in-out 200ms;
  cursor: pointer;
  padding: 0 2rem;

  h2 {
    font-size: 2.6rem;
    line-height: 1.2;
    font-weight: 600;
    padding: 1.4rem 0;
  }

  &&:hover {
    border-color: #d97706;
  }
`;

export const PromotionExample = styled.div`
  ${({ url }) => css`
    background-image: url(${url});
    width: 10rem;
    height: 100%;
    background-size: cover;
    justify-self: end;
  `}
`;
